function getBondsBaseUrl() {
  const runtime = useRuntimeConfig();
  const base = runtime.public.BONDS_API_BASE_URL || "https://prod-api.equirize.com";
  return base.replace(/\/$/, "");
}

function getBondsPath() {
  const runtime = useRuntimeConfig();
  const path = runtime.public.BONDS_API_PATH || "/bonds/bonds";
  return path.startsWith("/") ? path.replace(/\/$/, "") : `/${path.replace(/\/$/, "")}`;
}

function bondsUrl(endpoint) {
  return `${getBondsBaseUrl()}${getBondsPath()}${endpoint}`;
}

class bondsService {
  async getBondsListings(params = {}) {
    const url = bondsUrl("/listings");
    const queryParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value === undefined || value === null) return;

      if (typeof value === "object" && !Array.isArray(value)) {
        queryParams.set(key, JSON.stringify(value));
        return;
      }

      if (Array.isArray(value) && value.some((item) => typeof item === "object" && item !== null)) {
        queryParams.set(key, JSON.stringify(value));
        return;
      }

      queryParams.set(key, String(value));
    });
    const queryString = queryParams.toString();
    const fullUrl = queryString ? `${url}?${queryString}` : url;
    return $fetch(fullUrl, {
      headers: { "Content-Type": "application/json" },
      method: "GET",
    });
  }

  async getBondDetails(isin) {
    const url = bondsUrl("/details");
    const fullUrl = `${url}?isin=${encodeURIComponent(isin)}`;
    return $fetch(fullUrl, {
      headers: { "Content-Type": "application/json" },
      method: "GET",
    });
  }

  async getBondDetailsData(isin) {
    const url = bondsUrl("/details-data");
    const fullUrl = `${url}?isin=${encodeURIComponent(isin)}`;
    const response = await $fetch(fullUrl, {
      headers: { "Content-Type": "application/json" },
      method: "GET",
    });

    return {
      ...response,
      success: Boolean(response?.listing),
    };
  }

  async submitLead(name, phone, isin, listingName, investmentAmount) {
    const url = bondsUrl("/leads/submit");
    return $fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        name,
        phone,
        isin,
        listingName: listingName || undefined,
        investmentAmount,
        cta: "bond-interest-no-otp",
        sourceUrl: typeof window !== "undefined" ? window.location?.href : "",
      }),
    });
  }

  /**
   * Search bonds (active + trending + RFQ). Returns { bonds, totalBonds }.
   */
  async searchBonds(query, limit = 20) {
    const url = bondsUrl("/search");
    const params = new URLSearchParams({
      q: String(query).trim(),
      limit: Math.max(1, Math.min(50, Number(limit) || 20)),
    });
    return $fetch(`${url}?${params}`, {
      headers: { "Content-Type": "application/json" },
      method: "GET",
    });
  }
}

export default new bondsService();
